@if (group) {
    <div class="group">
        <div class="header">
            <mat-icon aria-hidden="true">folder</mat-icon>
            <div>
                <h3>{{group.name}}</h3>
                <span class="kind">Group</span>
            </div>
        </div>
        @if (group.tag) {
            <span class="tag" [style]="tagStyle">{{group.tag.name}}</span>
        }
        @if (group.description) {
            <p class="description">{{group.description}}</p>
        }
        <p class="note">Figures for the nodes in this group. Double-click the group in the canvas to open or close it.</p>
        <app-insight-cards [cards]="cards"></app-insight-cards>
    </div>
}@else {
    <p class="note">No group selected.</p>
}
